<template>
    <div class="blog">
        <Header/>
        <div class="title">
            <img :src="this.info.portada" alt="">
            <div class="marca"></div>
            <span>{{ this.info.subtitulo }}</span>
            <h2>{{ this.info.titulo }}</h2>
        </div>
        <div class="articules">
            <div class="escritor">
                <img :src="this.info.img" alt="">
                <div>
                    <label for="">{{ this.info.nombre }}</label>
                    <span>{{ this.info.fecha }}</span>
                </div>
            </div>
            <div class="list">
                <div v-for="(item, index) in Items" :key="index">
                    <center><img :src="item.info" alt="" v-if="item.name === 'imagen'"></center>
                    <p v-if="item.name === 'texto'">{{ item.info }}</p>
                    <center class="video" v-if="item.name === 'video'"><iframe width="100%" height="100%" :src="'https://www.youtube.com/embed/' + item.info" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></center>
                </div>
            </div>
        </div>
        <center><button><a :href="this.info.link" target="_blank">Contáctenos</a></button></center>
        <h1>Tambien te puede interesar: </h1>
        <div class="articule-list">
            <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="200">
                <div v-for="(item, index) in articules" :key="index">
                    <div class="image"><img :src="item.portada" alt=""></div>
                    <div class="infos">
                        <span>{{ item.subtitulo }}</span>
                        <h3>{{ item.titulo.substring(0,30) + '...'  }}</h3>
                        <p>{{ item.info.substring(0,100) + '...' }}</p>
                        <button @click="$router.push('/blog/' + item.id + '/' + item.titulo)">Ver mas</button>
                        <div>{{ item.nombre }}</div>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
</template>

<script>
import Header from './../Header/Header'
import Footer from './../Footer/Footer'
import API from '@/api'

export default {
    name: 'blog',
    data() {
        return {
            Items: [],
            imagen: null,
            articules: [],
            info: {
                portada: null,
                titulo: null,
                subtitulo: null,
                nombre: null,
                img: null,
                fecha: null,
                link: null
            },
            blog_id: null
        }
    },
    watch: {
        $route(to, from) {
            this.blog_id = to.params.blog_id
            this.getItems()
            this.getBlogInfo()
        }
    },
    components: {
        Footer,
        Header
    },
    methods: {
        getArticulesList() {
            API.getArticulesList(4, 0)
                .then((res) => {
                    this.articules = res
                })
        },
        getItems() {
            API.getItems(this.blog_id)
                .then((res) => {
                    this.Items = res
                })
        },
        getBlogInfo() {
            API.getBlogInfo(this.blog_id)
                .then((res) => {
                    this.info.portada = res.portada
                    this.info.titulo = res.titulo
                    this.info.subtitulo = res.subtitulo
                    this.info.nombre = res.nombre
                    this.info.img = res.img
                    this.info.fecha = res.fecha
                    this.info.link = res.link
                })
        }
    },
    beforeMount() {
        this.blog_id = this.$route.params.blog_id
    },
    mounted() {
        this.getItems()
        this.getArticulesList()
        this.getBlogInfo()
    }
}
</script>

<style scoped>
    h1 {
        text-align: center;
        color: #2d4f98;
        font-family: 'JBD';
    }
    button {
        font-family: 'JR';
        padding: 5px 20px 5px 20px;
        background-color: #65b24a;
        color: #fff;
        border-radius: 10px;
        font-size: 24px;
        margin-right: 15px;
        border-color: #65b24a;
        border-style: solid;
        letter-spacing: 1pt;
        margin-top: 20px;
        margin: 40px;
    }
    button:hover{
        background:#2d4f98;
        color: #fff;
        border-radius: 10px;
        border-color: #fff;
    }
    button > a {
        outline: none;
        text-decoration: none;
        color: #fff;
    }
    .title {
        padding: 200px 200px;
        color: #fff;
        background-position: center;
        background-repeat: no-repeat;
        background-size: auto 100%;
        position: relative;
    }
    .title > img {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        object-fit: cover;
    }
    .title .marca {
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba(45, 79, 152, 0.9);
        width: 100%;
        height: 100%;
    }
    .title > span {
        position: relative;
        font-family: 'JLI';
        font-size: 22px;
    }
    .title > h2 {
        position: relative;
        font-family: 'JBD';
        font-size: 50px;
    }
    .articules {
        padding: 20px 300px;
    }
    .articules > .escritor {
        display: flex;
    }
    .articules > .escritor > img{
        width: 150px;
        height: 150px;
        object-fit: cover;
        border-radius: 50%;
        display: inline-block;
        margin-right: 30px;
    }
    .articules > .escritor > div {
        margin-top: 50px;
        display: grid;
        height: 100px;
    }
    .articules > .escritor > div > label{
        color: #2d4f98;
        font-family: 'JBD';
        height: 20px;
        font-size: 24px;
    }
    .articules > .escritor > div > span{
        color: #2d4f98;
        font-family: 'JR';
    }
    .articules > .list {
        margin-top: 50px;
    }
    .articules > .list > div > p{
        margin-top: 20px;
        white-space: pre-line;
        text-align: justify;
    }
    .articules > .list > div > center{
        margin-top: 40px;
    }
    .articules > .list > div > center > img {
        width: 100%;
        height: auto;
        max-height: 600px;
        object-fit: cover;
    }
    .articules > .list > div > center > iframe {
        height: 30vw;
    }
    .articule-list {
        padding: 20px 100px;
        width: 100%;
    }
    .articule-list > div {
        width: 100%;
    }
    .articule-list > div > div{
        width: 50%;
        display: inline-flex;
    }

    .articule-list > div > div > div.image {
        padding: 20px;
        display: inline-block
    }

    .articule-list > div > div > div.image > img{
        object-fit: cover;
        width: 300px;
        height: 350px;
    }

    .articule-list > div > div > div.infos {
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0, 0, 0, 0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0, 0, 0, 0.07);
        box-shadow: 10px 10px 26px 0px rgba(0, 0, 0, 0.07);
        width: 100%;
        height: 400px;
        padding: 10;
        padding-top: 20px;
        margin-top: 80px;
        margin-left: -100px;
        z-index: 0;
        padding-left: 100px;
        text-align: justify;
        font-family: 'JR';
        position: relative;
    }
    .articule-list > div > div > div.infos > div{
        padding: 20px;
        float: right;
        color: #2d4f98;
        font-weight: bold;
        font-style: oblique;
    }

    .articule-list > div > div > div.infos > span{
        margin-top: 1000px;
        color: #000;
        font-weight: bold;
    }
    .articule-list > div > div > div.infos > h3{
        margin-top: 20px;
        color: #2d4f98;
        text-align: left;
        font-family: 'JBD';
    }
    .articule-list > div > div > div.infos > p{
        color: #000;
        text-align: left;
    }
    .articule-list > div > div > div.infos > button{
        position: absolute;
        background-color: #65b24a;
        width: 150px;
        height: 40px;
        text-align: center;
        border-radius: 20px;
        padding: 5px;
        border-color: #65b24a;
        border-style: solid;
        font-size: 20px;
        color: #fff;
        margin-top: 20px;
        bottom: 40px;
        cursor: pointer;
    }

    .articule-list > div > div > div > button:hover {
        color: #65b24a;
        background-color: #fff;
        cursor: pointer;
    }

    @media (max-width: 1500px) {
        .articules {
            padding: 20px 200px;
        }
        .title {
            padding: 200px 200px;
        }
        .info > h1 {
            padding-left: 200px;
        }
    }

    @media (max-width: 1400px) {
        .articule-list {
            padding: 20px 20px;
            width: 100%;
        }
        .title {
            padding: 200px 100px;
        }
        .info > h1 {
            padding-left: 100px;
        }
    }

    @media (max-width: 1300px) {
        .articules {
            padding: 20px 100px;
        }
        .info > h1 {
            font-size: 30px;
        }
        .articule-list {
            padding: 20px 100px;
            width: 100%;
            display: inline-flex;
        }
        .articule-list > div > div{
            width: 50%;
            align-items: center;
            justify-items: center;
            display: inline-block;
        }
        .articule-list > div > div > div.image {
            padding: 20px;
            display: grid;
            align-items: center;
            justify-items: center;
        }
        .articule-list > div > div > div.infos {
            margin-top: -30px;
            width: 100%;
            margin-left: 0px;
            align-items: center;
            justify-items: center;
        }
        .articule-list > div > div > div.infos > button{
            left: 50px;
        }
        .articule-list > div > div > div.infos > div{
            margin-top: 50px;
        }
    }

    @media (max-width: 1100px) {
        .articule-list {
            padding: 20px 20px;
            width: 100%;
        }
        #contactForm {
            margin-top: -100px;
            right: 50px;
        }
    }

    @media (max-width: 1000px) {
        .title {
            padding: 50px 0px;
            height: 400px;
            text-align: center;
        }
        #contactForm {
            margin-top: 10px;
            left: 0;
            right: 0;
            margin: auto;
        }
        .info {
            padding-top: 400px;
            width: 100%;
            text-align: center;
        }
        .info > h1 {
            padding: 10px;
            width: 100%;
            text-align: center;
        }
        .articule-list {
            padding: 20px 20px;
            width: 100%;
        }
        .articule-list > div {
            display: grid;
            align-items: center;
            justify-items: center;
        }
        .articule-list > div > div{
            display: flex;
            width: 80%;
        }
        .articule-list > div > div > div.infos {
            margin-left: -100px;
        }
        .articule-list > div > div > div.infos > button{
            left: 100px;
        }
    }

    @media (max-width: 800px) {
        .articules {
            padding: 20px 50px;
        }
        .articule-list {
            padding: 20px 20px;
            width: 100%;
        }
        .articule-list > div {
            display: grid;
            align-items: center;
            justify-items: center;
        }
        .articule-list > div > div{
            display: flex;
            width: 100%;
        }
        .articule-list > div > div > div.infos > button{
            left: 100px;
        }
    }

    @media (max-width: 750px) {
        .articule-list {
            padding: 20px 20px;
            width: 100%;
        }
        .articule-list > div {
            display: grid;
            align-items: center;
            justify-items: center;
        }
        .articule-list > div > div{
            display: grid;
            width: 100%;
        }
        .articule-list > div > div > div.infos > button{
            left: 100px;
        }
    }

    @media (max-width: 500px) {
        #contactForm {
            width: 300px;
        }
        .articules > .escritor > div > label{
            font-size: 18px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Blog/Blog.vue